import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatOptionModule } from '@angular/material/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule } from "@angular/router";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import { SharedModule } from "../../shared/shared.module";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { IncomeSharedModule } from "../shared/income-shared.module";

import { CustomerAdvancePaymentListComponent } from "./components/customer-advance-payment-list/customer-advance-payment-list.components";
import { CustomerAdvancePaymentFormV2Component } from "./components/customer-advance-payment-form/customer-advance-payment-form.component";
import { CustomerAdvancePaymentService } from "./services/customer-advance-payment.service";
import { CustomerAdvancePaymentReducer } from "./store/reducers/customer-advance-payment.reducer";
import { CustomerAdvancePaymentEffects } from "./store/effects/customer-advance-payment.effects";

@NgModule({
  declarations: [
    CustomerAdvancePaymentListComponent,
    CustomerAdvancePaymentFormV2Component,
  ],
  exports: [
    CustomerAdvancePaymentListComponent,
    CustomerAdvancePaymentFormV2Component,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    SharedModule,
    IncomeSharedModule,
    RouterModule,
    FormsModule,

    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,
    MatOptionModule,
    MatDatepickerModule,
    DragDropModule,

    StoreModule.forFeature('customerAdvancePayment', CustomerAdvancePaymentReducer),
    EffectsModule.forFeature([CustomerAdvancePaymentEffects]),
  ],
  providers: [
    CustomerAdvancePaymentService,
  ]
})
export class CustomerAdvancePaymentModule { }
